<template>
  <div>
    <servicos-modal v-if="modalSelecionarServico" v-model="modalSelecionarServico" permiteSelecionar
                    @selecionarServico="selecionarServico"
                    @fecharModalServicos="fecharModalServico"/>
    <servico-orcamento-cadastro-modal
        v-if="modalAdicionarServico"
        v-model="modalAdicionarServico"
        :orcamentoId="idOrcamento"
        :servico="servicoSelecionado"
        @fecharModalCadastrarServicoOrcamento="fecharModalAdicionarServico"
        @fecharModalCadastroServicoOrcamento="fecharModalCadastroServico"
    />
    <servico-orcamento-editar-modal
        v-if="modalEditarServicoOrcamento"
        v-model="modalEditarServicoOrcamento"
        :servicoOrcamento="servicoOrcamentoSelecionado"
        :orcamentoId="idOrcamento"
        @fecharModalEditarServicoOrcamento="fecharModalEdicaoServico"
    />
    <div class="header-gerenciamento-servicos">
      <span class="primary--text">Serviços</span>
    </div>
    <div class="container-acoes-servicos">
      <v-tooltip right v-if="statusOrcamento === 'EM_ANDAMENTO'">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed @click="adicionarServico">
            <v-icon>build</v-icon>
          </v-btn>
        </template>
        Adicionar serviço ao orçamento
      </v-tooltip>
      <v-tooltip right v-if="statusOrcamento === 'CANCELADO'">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed disabled class="btn-disabled">
            <v-icon>build</v-icon>
          </v-btn>
        </template>
        Não é possível adicionar serviços, o orçamento está cancelado.
      </v-tooltip>
      <v-tooltip right v-if="statusOrcamento === 'FINALIZADO'">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" depressed disabled class="btn-disabled">
            <v-icon>build</v-icon>
          </v-btn>
        </template>
        Não é possível adicionar serviços, o orçamento está finalizado.
      </v-tooltip>
      <div class="container-total">
        <span>Total</span><br/>
        <label>{{ valorTotalGeral | valorParaReal }}</label>
      </div>
    </div>
    <v-container fluid grid-list-xl white class="pa-0">
      <OrcamentoServicoTabela
          :itens="itens"
          :paginas="paginas"
          :total-itens="totalItens"
          :paginacao="$store.state.servicoOrcamento.resultadoBuscaTodosServicosOrcamento.paginacao"
          @acessar="tratarEventoAcessarServico"
          @paginar="tratarEventoPaginar"
      />
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/core/constants'
import ServicosModal from '@/views/modais/servicos/ServicosModal.vue'
import OrcamentoServicoTabela
from '@/views/pages/cadastros/paciente/comum/orcamento/servicos/OrcamentoServicoTabela.vue'
import ServicoOrcamentoCadastroModal
from '@/views/pages/cadastros/paciente/comum/orcamento/servicos/ServicoOrcamentoCadastroModal.vue'
import ServicoOrcamentoEditarModal
from '@/views/pages/cadastros/paciente/comum/orcamento/servicos/ServicoOrcamentoEditarModal.vue'

export default {
    name: 'OrcamentoServico',
    props: {
        idOrcamento: {
            type: Number,
            required: true
        },
        statusOrcamento: {
            type: String,
            required: true
        },
    },
    components: {
        ServicoOrcamentoEditarModal,
        ServicoOrcamentoCadastroModal,
        OrcamentoServicoTabela,
        ServicosModal
    },
    data() {
        return {
            filtrosInterno: this.getFiltros(),
            modalSelecionarServico: false,
            modalAdicionarServico: false,
            modalEditarServicoOrcamento: false,
            servicoOrcamentoSelecionado: null,
            itens: [],
            paginas: 0,
            totalItens: 0,
            valorTotalGeral: 0,
            servicoSelecionado: null
        }
    },
    methods: {
        async buscar() {
            this.$store.commit(mutationTypes.SERVICO_ORCAMENTO.SET_FILTROS_BUSCA_TODOS_SERVICOS_ORCAMENTO, this.getFiltrosInterno())
            await this.buscarServicos()
        },
        async buscarServicos() {
            const resposta = await this.$store.dispatch(actionTypes.SERVICO_ORCAMENTO.BUSCAR_TODOS_SERVICOS, this.idOrcamento)
            if (resposta) {
                this.itens = resposta.items
                this.paginas = resposta.totalPages
                this.totalItens = resposta.totalElements
                this.valorTotalGeral = resposta.valorTotalGeral
            }
        },
        getFiltros() {
            return _.cloneDeep(this.$store.state.servicoOrcamento.resultadoBuscaTodosServicosOrcamento.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        tratarEventoPaginar(paginacao) {
            this.$store.commit(mutationTypes.SERVICO_ORCAMENTO.SET_PAGINACAO_BUSCA_TODOS_SERVICOS_ORCAMENTO, paginacao)
            this.buscar()
        },
        tratarEventoAcessarServico(item) {
            this.servicoOrcamentoSelecionado = item
            this.modalEditarServicoOrcamento = true
        },
        fecharModalEdicaoServico() {
            this.modalEditarServicoOrcamento = false
            this.servicoOrcamentoSelecionado = null
            this.buscar()
        },
        adicionarServico() {
            this.modalSelecionarServico = true
        },
        fecharModalServico() {
            this.modalSelecionarServico = false
        },
        selecionarServico(item) {
            this.fecharModalServico()
            this.servicoSelecionado = item
            this.modalAdicionarServico = true
        },
        fecharModalAdicionarServico() {
            this.modalAdicionarServico = false
            this.servicoSelecionado = null
            this.adicionarServico()
        },
        fecharModalCadastroServico() {
            this.modalAdicionarServico = false
            this.servicoSelecionado = null
            this.buscar()
        }
    }
}
</script>

<style scoped lang="stylus">

.header-gerenciamento-servicos
  margin-top 10px
  border-bottom 1px solid #ddd

  span
    font-weight bold

.container-acoes-servicos
  margin-top 10px
  display flex
  justify-content space-between

.container-total
  span
    font-weight bold
    color var(--theme-primary)

</style>